export const categorySymbolicNames = {
  ONLINE_SCHOOL: 'onlajn-skola',
}
